$(function(){
	$(window).load(function(){
		var tab_num =	location.hash.split("#")[1];

		if(tab_num){
			var tab_num2 =	tab_num.split("tab")[1];
//			setTimeout(function(){
//				$("html,body").scrollTop($(".naviUL").offset().top-150)
//				var $fff= $(".naviUL a").eq(Number(tab_num2)-1)
//				$(".fixedBox").scrollLeft(($fff.offset().left+($fff.width()/2))-$(window).width()/2)
//			},100)
//
		 $(".naviUL a").removeClass("on");
		 $(".naviUL a").eq(Number(tab_num2)-1).addClass("on");
	 	 var tabContents = "#"+location.hash.split("#")[1];
	 	 $(tabContents).addClass("active").siblings(".active").removeClass("active");
		}




if($(window).width()<480){
var h = 45;
}else if($(window).width()<1200){
	var h = 60;
}else{
	var h = 112;
}

	var top = $('#main .fixedBox').offset().top - h;
	$(window).scroll(function(){
		var scroll = $(window).scrollTop();
		if(scroll > h){
			$('#gHeader').addClass('fixed');
		}else {
			$('#gHeader').removeClass('fixed');
		}
		if(scroll > top){
			$('#main .fixedBox').addClass('fixed').css('top',h);
		}else {
			$('#main .fixedBox').removeClass('fixed').css('top',0);
		}
	})

	$(".naviUL a").click(function() {
	 $(this).parent().addClass("active").siblings(".active").removeClass("active");
	 $(".naviUL a").removeClass("on")
	 $(this).addClass("on")
	 var tabContents = $(this).attr("href");
	 $(tabContents).addClass("active").siblings(".active").removeClass("active");
	 return false;
 });

	$(".naviUL a").each(function(){
	 var $href = $(this).attr('href');
	 if(location.href.match($href)) {
	 $(this).addClass('active-tab');
	 } else {
	 $(this).removeClass('active-tab');
	 }
 });

  // ページネーションアンカーリンク
	var hash = $( location ).attr('#shopBox');
	if(hash){
		var target_shopBox = $('#shopBox').offset().top;
		$('html,body').animate({scrollTop: target_shopBox}, 'slow');
	}


});


	var localLink = window.location+'';
	if(localLink.indexOf("#") != -1 && localLink.slice(-1) != '#'){
		localLink = localLink.slice(localLink.indexOf("#")+1);
		//$('html,body').animate({scrollTop: $('#'+localLink).offset().top}, 500);
	}

		$('[data-fancybox]').fancybox({
				touch: false,
	smallBtn: false,
		});
		op_anime()

		$(window).scroll(function(){
			var windowHeight = $(window).height(),
			topWindow = $(window).scrollTop();
			$('.fadein').each(function(){
				var targetPosition = $(this).offset().top;
				if(topWindow > targetPosition - windowHeight){
					$(this).addClass("scrollin");
				}
			});
		}).trigger("scroll");
})
$(document).ready(function(){
		$("#edit").click(function(){
				$("#action").val('edit');
		});
		$("#submit").click(function(){
				$("#action").val('submit');
		});
});






function op_anime(){
	$("#cover").fadeOut(400)
  TweenLite.to($(".mainVisual .photo"), 0, { scale:1.1});
  TweenLite.to($(".mainVisual .photo"), 1.3, { scale:1});
  $(".mainVisual .textBox").css("opacity",0)
TweenLite.to($(".mainVisual  .textBox"), 0.8, { opacity:1,delay:0.6});
}
